import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../AppContext";
import { routePaths } from "../../../infrastructure/routes/routePaths";

/** Whether this session is a global admin inside someone else's profile, and how to leave it. */
export const useImpersonationBanner = () => {
  const { currentUser } = useAppContext();
  const navigate = useNavigate();

  const adminName = currentUser?.impersonatedBy;
  const userName = [currentUser?.firstName, currentUser?.lastName]
    .filter(Boolean)
    .join(" ");

  return {
    isVisible: !!adminName,
    adminName,
    userName,
    exit: () => navigate(routePaths.logout),
  };
};
